export default __webpack_public_path__ + "ab93b4ef0e6edee37e83b6a7136a7dfd.png";